import InfoCard from '@/components/ui/InfoCard';
import { EmptyShipmentCardProps } from './types';
import { Package } from 'lucide-react';

const EmptyShipmentCard = (props: EmptyShipmentCardProps) => {
  const {
    message
  } = props;

  return (
    <InfoCard
      description={(
        message ? (
          message
        ) : (
          <>
            <span className="block">Нет активных поставок.</span>
            <span className="block">
              Создайте первую поставку через чат с ИИ-агентом — загрузите инвойс или опишите товар.
            </span>
          </>
        )
      )}
      icon={<Package className="size-6 shrink-0 text-muted-foreground" strokeWidth={1.75} />}
    />
  );
};

export default EmptyShipmentCard;